<mat-accordion class="payment-schedule"
               ngClass.lt-md="payment-schedule-sm"
               ngClass.xs="payment-schedule-xs">
  <mat-expansion-panel class="mat-elevation-z0">

    <mat-expansion-panel-header>
      <mat-panel-title class="secondary-text">
        PAYMENT SCHEDULE
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div fxLayout="column"
         class="mat-elevation-z2">
      <ifc-offer-payment-schedule-table [offerDetail]="offer"
                                        [sampleDraw]="sampleDraw"
                                        [isPublicView]="isPublicView">
      </ifc-offer-payment-schedule-table>
    </div>

  </mat-expansion-panel>
</mat-accordion>

<div class="disclaimer">
  <span class="secondary-text">
    The information provided on this page is an estimate only. 
    Calculations assume that all payments are made when scheduled and there are no additional payments toward principal. 
    Actual payment amount and dates may vary.
  </span>
</div>